var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['move-model', {'move-model--compressed': _vm.display_compressed}]},[_c('div',{staticClass:"move-model__title"},[_vm._v(_vm._s(_vm.model.label))]),_vm._v(" "),_c('div',{staticClass:"move-model__body"},_vm._l((_vm.model.items),function(item){return _c('move-item',{key:item.id,attrs:{"item":item,"options":_vm.options}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }